// Lot 734 — profil « allégé » pour les téléphones à faible mémoire, appliqué D'OFFICE (sans attendre un plantage) :
//   • Android : ≤ 2 Go annoncés par navigator.deviceMemory (un 3 Go est annoncé « 2 » : couvert) ;
//   • iPhone : ≤ 3 Go de RAM totale (memoryInfo natif, mémorisé dès la 1re lecture : la mesure est asynchrone) ;
//   • tout appareil : alerte mémoire système reçue, ou boucle de redémarrages (mode allégé) → 7 jours.
// Effets (vidéos du fil / Reels / stories) : définition plafonnée à 480p, tampons hls.js réduits, fil fenêtré plus serré.
// Garde-fou admin « low_memory_lite » pour revenir au comportement normal à distance.
import { guardOn } from "@/lib/guards";

export const LOW_MEMORY_GB = 2;
export const IOS_LOW_TOTAL_MB = 3100;
export const LITE_MAX_HEIGHT = 480;
export const LITE_DAYS_MS = 7 * 24 * 60 * 60 * 1000;
const KEY = "yalola.lite";

// navigator.deviceMemory : exposé par Chrome / WebView Android (0.25 … 8). iOS ne l'expose pas → jamais « faible » ici.
export const lowMemoryDevice = () => {
  const gb = typeof navigator !== "undefined" ? navigator.deviceMemory : undefined;
  return typeof gb === "number" && gb > 0 && gb <= LOW_MEMORY_GB;
};

const readPersisted = () => { try { return JSON.parse(localStorage.getItem(KEY) || "null"); } catch { return null; } };
const persist = (reason, untilMs) => {
  const cur = readPersisted();
  if (cur?.reason === "ios-3go") return; // le matériel prime : rien à écraser
  try { localStorage.setItem(KEY, JSON.stringify({ reason, until: untilMs })); } catch { /* noop */ }
};

// Raison du profil allégé, ou null. Lecture synchrone (utilisable au branchement d'une vidéo).
export const liteReason = (now = Date.now()) => {
  if (!guardOn("low_memory_lite")) return null;  // garde-fou admin coupé : plus aucune détection ni effet
  if (lowMemoryDevice()) return "android-2go";
  const p = readPersisted();
  if (!p?.reason) return null;
  if (p.until && now > p.until) return null;
  return p.reason;
};
export const liteVideoProfile = (now = Date.now()) => !!liteReason(now);

// Relevé mémoire natif (iPhone) : RAM totale ≤ 3 Go → allégé définitivement sur cet appareil.
export const noteNativeMemory = (m) => {
  if (!guardOn("low_memory_lite")) return;
  if (m && typeof m.totalMb === "number" && m.totalMb > 0 && m.totalMb <= IOS_LOW_TOTAL_MB) { try { localStorage.setItem(KEY, JSON.stringify({ reason: "ios-3go", until: 0 })); } catch { /* noop */ } }
};
export const noteMemoryWarning = (now = Date.now()) => { if (guardOn("low_memory_lite")) persist("memory-warning", now + LITE_DAYS_MS); };
export const noteRestartLoop = (now = Date.now()) => { if (guardOn("low_memory_lite")) persist("restart-loop", now + LITE_DAYS_MS); };

// hls.js : tampons réduits (mémoire du décodeur + du cache de segments divisée par ~3).
export const liteHlsConfig = () => ({ backBufferLength: 5, maxBufferLength: 12, maxMaxBufferLength: 20, maxBufferSize: 20 * 1000 * 1000 });
// Indice du niveau le plus haut ≤ 480p (hls.js `autoLevelCapping`) ; -1 = pas de plafond (aucun niveau ≤ 480p).
export const liteLevelCap = (levels) => {
  let cap = -1;
  (levels || []).forEach((lv, i) => { const h = Math.min(lv?.width || Infinity, lv?.height || Infinity); if (h <= LITE_MAX_HEIGHT && (cap < 0 || h >= Math.min(levels[cap].width || Infinity, levels[cap].height || Infinity))) cap = i; });
  return cap;
};
export const _resetLiteForTests = () => { try { localStorage.removeItem(KEY); } catch { /* noop */ } };
